import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

class PaymentUpdateWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id = parseInt(this.component.props.params.fileId, 10);
    this.component.fileId = id;
    const filter = this.component.props.app?.transactionsFilterStates?.[id]?.["filter"] || "unverified";

    this.component.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_NOT_SAVE_LIST,
      payload: {
        transactionFileId: id,
        sortBy: "+dateOfThePayment"
      },
      onSuccess: data => {
        const showTransactionPaymentsList = this.component.props.app.showTransactionPaymentsList;

        const payments = [...data.payments];
        const transactionFile = this.component.props.app.transactionFiles
            .filter(transactionFile => transactionFile.removed === false)
            .find(transactionFile => transactionFile.id === id);
        const paymentsToVerify = payments.filter(payment => !payment.removed);
        const currentPayment = paymentsToVerify[0];

        if (!showTransactionPaymentsList) {
          this.component.props.dispatch({
            type: Constants.TRANSACTION_FILTER_UPDATE_STATE,
            payload: {
              fileId: id,
              filter: filter,
              transactionIds: paymentsToVerify.map(payment => payment.id)
            }
          });

          return this.component.redirect(`/app/transaction-file/${id}/bank-transaction/${currentPayment?.id}`);
        }

        if (payments.length === 0) {
          return this.component.setState({
            hasModifiedData: false
          }, this.component.redirectBack);
        }

        let state = {
          payments: payments,
          paymentsToVerify: paymentsToVerify,
          currentPayment: currentPayment,
          hasModifiedData: true,
          transactionFile: transactionFile,
          filter: filter
        };

        this.component.setState({
          ...state
        }, () => {
          this.component.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          this.component.props.dispatch({
            type: Constants.GLOBAL_CHARGE_CREATE_CLEAR
          });
        });
      }
    });
  }
}

export default new PaymentUpdateWillMount();
